import "regenerator-runtime";
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default-dark.css'
import 'vue-material/dist/theme/default.css'
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { io } from "socket.io-client";
import moment from 'vue-moment';
import { createProvider } from './vue-apollo';
import { getCookieValue } from './utils';
import wysiwyg from "vue-wysiwyg";
import VueClipboard from 'vue-clipboard2';
import * as Sentry from "@sentry/vue";

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(VueMaterial);

library.add(fas);
library.add(fab);
library.add(far);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);
Vue.component('fa-layers-text', FontAwesomeLayersText);

Vue.use(VueClipboard);

//needed to load the .env file
require('dotenv').config();

import $ from 'jquery';
window.$ = $;

import lodash from 'lodash'

import router from './routes';
import store from './store';
import _ from 'lodash';

Vue.use(VueResource);
Vue.http.options.credentials = 'include';
Vue.http.interceptors.push((request) => {

  //for authorizating the http calls
  const token = getCookieValue('access_token')
  request.headers.set('Authorization', `Bearer ${token}`)
  request.headers.set('Accept', 'application/json')

  // return response callback
  return function(response) {
    if (response.status === 401) {
      if (router.currentRoute.meta.requiresAuth) router.push({name: 'LogIn'})
    }
  };
})

// Websocket initialization
export const socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
  withCredentials: true,
});

socket.on('connect', () => {
  console.log("WEBSOCKET STARTED", socket.id)
})

socket.on('disconnect', () => {
  console.log("WEBSOCKET DISCONNECTED")
  // reconnecting
  socket.connect()
})

Vue.use(moment);
Vue.use(wysiwyg, {});

Vue.filter('date', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'DD/MMM/YY');
});

Vue.filter('datetime', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'DD/MMM/YY h:mm a');
});

Vue.filter('since', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'from');
});

Vue.filter('monthYear', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'MMMM YYYY');
});

Vue.filter('year', value => {
  const vf = Vue.filter('moment');
  return vf(value, 'YYYY');
});

Vue.filter('durationInMinutes', value => {
  const vf = Vue.filter('duration');
  return vf(value * 1000, 'minutes');
});

Vue.filter('metersToKilometers', value => {
  return (value / 1000).toFixed(2)
});

Vue.filter('meters', value => {
  return value.toFixed(0)
});

Vue.filter('numberOfStages', itineary => {
  return itineary.filter(step => step.type === 'stage').length
});

function convertSecondsToMinutes(s) {
  return(s-(s%=60))/60+(9<s?':':':0')+s
}

Vue.filter('secondsToMinutes', s => {
  return convertSecondsToMinutes(s)
});

Vue.filter('getStageTime', (details, stageNumber) => {
  const indexToGet = (stageNumber * 2) - 2
  return convertSecondsToMinutes(details[indexToGet].time)
});

Vue.filter('capitalize', string => {
  return _.capitalize(string)
});

Vue.filter('validated', validated => {
  return validated ? 'Yes' : 'No'
});

// make some objects globally available
Vue.mixin({
  data: function() {
    return {
      get lodash() {
        return lodash
      },
      get socket() {
        return socket;
      },
      get getMonthAndYear() {
        const currentDate = new Date()
        const currentMonth = currentDate.getMonth() + 1
        const currentYear = currentDate.getFullYear()
  
        const pastMonth = (currentMonth === 1) ? 12 : currentMonth - 1;
        const pastYear = (currentMonth === 1) ? currentYear - 1 : currentYear;
        const pastDate = new Date(`${pastYear}-${pastMonth}-01`)
  
        return {
          current: {
            month: currentMonth,
            year: currentYear,
            date: currentDate
          },
          past: {
            month: pastMonth,
            year: pastYear,
            date: pastDate
          }
        }
      }
    }
  }
})

Sentry.init({
  Vue,
  dsn: "https://65ad96014afb40a8b83aefa632cb498b@o4505291556454400.ingest.sentry.io/4505291744149504",
  integrations: [
    new Sentry.BrowserTracing({
      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/back.endurobiking\.com\/api/, /^https:\/\/endurobiking\.com/],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

new Vue({
  render: h => h(App),
  store,
  router,
  apolloProvider: createProvider(),
}).$mount('#app')
